"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Component = void 0;
var Preact = __importStar(require("preact"));
var Box_1 = __importDefault(require("@mui/material/Box"));
var Drawer = __importStar(require("./A_Drawer"));
var DrawerTitle = __importStar(require("./O_DrawerTitleGrouping"));
/** Wraps Drawer but adds a title with no background colour */
var Component = function (p) {
    var _a;
    return (Preact.h(Drawer.Component, { platform: p.platform, portrait: p.portrait, sx: p.sx, open: p.open, anchor: p.anchor, onClose: p.onClose, paddingTop: p.paddingTop, mountOptions: p.mountOptions },
        Preact.h(Box_1.default, { display: "flex", flexDirection: "column", height: "100%" },
            Preact.h(Box_1.default, { flexGrow: "0" },
                Preact.h(DrawerTitle.Component, { title: p.title, onCloseClick: p.onClose, buttonText: p.titleButtonText, buttonOnClick: p.titleButtonOnClick, buttonDisabled: p.titleButtonDisabled })),
            Preact.h(Box_1.default, { paddingX: "24px", flexGrow: "1", overflow: "auto" }, (_a = p.children) !== null && _a !== void 0 ? _a : null))));
};
exports.Component = Component;
